/**
 * Die Farben der Diagramme.
 *
 * **Warum kein Diagrammpaket.** Fuenf Formen -- Balken, Ring, Linie, Bahn,
 * Verlaufsstrich -- rechtfertigen keine Abhaengigkeit. docs/04, Abschnitt 11
 * verlangt fuer jede eine Begruendung, und die Rechnung geht hier nicht auf:
 * Ein uebliches Diagrammpaket bringt Dutzende weiterer Pakete mit, die
 * allesamt in einer Anwendung landen, die eine Datenschutzpruefung bestehen
 * muss. Dazu kommt, dass jedes dieser Pakete eigene Farben und eigene
 * Beschriftungen mitbringt -- man verbringt mehr Zeit damit, sie abzuschalten,
 * als das Gleiche selbst zu zeichnen.
 *
 * Was hier steht, ist SVG und CSS aus dem Gestaltungssystem. Die Farbwerte
 * selbst stehen in ``theme.css`` und nirgendwo sonst.
 */

/** Wie viele Toene die Palette kennt, bevor sie von vorn beginnt. */
export const CHART_COLOURS = 8;

/**
 * Der Farbton fuer die ``index``-te Reihe.
 *
 * Bei mehr als acht Reihen wiederholen sich die Toene. Das ist bewusst nicht
 * abgefangen: Ein Diagramm mit neun Kategorien ist ohnehin unlesbar, und die
 * Aufrufer hier schneiden vorher ab -- siehe ``topN``.
 */
export function chartColour(index: number): string {
  return `var(--chart-${String((index % CHART_COLOURS) + 1)})`;
}

/**
 * Die groessten ``limit`` Eintraege, der Rest zu einer Zeile zusammengefasst.
 *
 * Ein Balkendiagramm mit vierzig Warteschlangen sagt nichts; eines mit acht
 * und einem "Uebrige" sagt dasselbe in einem Blick. Die Zusammenfassung
 * steht ausdruecklich dabei und wird nicht stillschweigend weggelassen --
 * eine Auswertung, die Zeilen verschweigt, ist in einer Pruefung wertlos.
 */
export function topN<T extends { value: number }>(
  rows: readonly T[],
  limit: number,
  rest: (value: number, count: number) => T,
): T[] {
  if (rows.length <= limit) return [...rows];

  const sorted = [...rows].sort((a, b) => b.value - a.value);
  const head = sorted.slice(0, limit);
  const tail = sorted.slice(limit);
  const sum = tail.reduce((total, row) => total + row.value, 0);
  return [...head, rest(sum, tail.length)];
}
